{
	"asset":{
		"generator":"Khronos glTF Blender I/O v4.1.62",
		"version":"2.0"
	},
	"scene":0,
	"scenes":[
		{
			"name":"Scene",
			"nodes":[
				0,
				1,
				2,
				3,
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12
			]
		}
	],
	"nodes":[
		{
			"mesh":0,
			"name":"body",
			"scale":[
				0.937124490737915,
				1,
				1
			],
			"translation":[
				0,
				2.146585464477539,
				0
			]
		},
		{
			"mesh":1,
			"name":"head",
			"scale":[
				0.8984315395355225,
				0.9587109684944153,
				0.9587109684944153
			],
			"translation":[
				0,
				3.987575054168701,
				0
			]
		},
		{
			"mesh":2,
			"name":"leg left",
			"scale":[
				0.08088663965463638,
				0.9437786936759949,
				0.0863136574625969
			],
			"translation":[
				0,
				0.9103175401687622,
				-0.46000000834465027
			]
		},
		{
			"mesh":3,
			"name":"leg right",
			"scale":[
				0.08088663965463638,
				0.9437786936759949,
				0.0863136574625969
			],
			"translation":[
				0,
				0.9103175401687622,
				0.46000000834465027
			]
		},
		{
			"mesh":4,
			"name":"hand right",
			"rotation":[
				0.5186985731124878,
				-0.0003136939776595682,
				-0.0015777591615915298,
				0.8549556732177734
			],
			"scale":[
				0.30448251962661743,
				0.5152471661567688,
				0.5152481198310852
			],
			"translation":[
				-0.24292363226413727,
				2.2653884887695312,
				1.5375065803527832
			]
		},
		{
			"mesh":5,
			"name":"foot left",
			"scale":[
				0.18387234210968018,
				0.18387234210968018,
				0.18387234210968018
			],
			"translation":[
				0.07565400004386902,
				0.12823782861232758,
				-0.4628182053565979
			]
		},
		{
			"mesh":6,
			"name":"foot right",
			"scale":[
				0.18387234210968018,
				0.18387234210968018,
				0.18387234210968018
			],
			"translation":[
				0.07565400004386902,
				0.12823782861232758,
				0.5771837830543518
			]
		},
		{
			"mesh":7,
			"name":"hand left",
			"rotation":[
				0.19500520825386047,
				-0.0008344011148437858,
				-0.001375319086946547,
				0.9808008670806885
			],
			"scale":[
				0.30448251962661743,
				0.5152471661567688,
				0.5152481198310852
			],
			"translation":[
				-0.2429235875606537,
				2.2653894424438477,
				-1.5375065803527832
			]
		},
		{
			"mesh":8,
			"name":"Cube",
			"rotation":[
				0,
				0,
				-0.18234197795391083,
				0.9832351803779602
			],
			"scale":[
				-0.608928382396698,
				-0.608928382396698,
				-0.6089284420013428
			],
			"translation":[
				-0.8017759919166565,
				4.231659889221191,
				0.34039801359176636
			]
		},
		{
			"mesh":9,
			"name":"Cube.001",
			"rotation":[
				0,
				0,
				-0.18234197795391083,
				0.9832351803779602
			],
			"scale":[
				-0.608928382396698,
				-0.608928382396698,
				-0.6089284420013428
			],
			"translation":[
				-0.8017759919166565,
				4.231659889221191,
				-0.34039801359176636
			]
		},
		{
			"mesh":10,
			"name":"Cylinder",
			"rotation":[
				0,
				0,
				0.7939595580101013,
				0.6079705953598022
			],
			"scale":[
				-0.13113990426063538,
				-0.12675873935222626,
				-0.09340132772922516
			],
			"translation":[
				-0.7421995997428894,
				3.8098058700561523,
				0
			]
		},
		{
			"mesh":11,
			"name":"Cube.002",
			"rotation":[
				0,
				0,
				-0.18223552405834198,
				0.9832549095153809
			],
			"scale":[
				-0.045032501220703125,
				-0.045032501220703125,
				-0.045032501220703125
			],
			"translation":[
				-0.7015438675880432,
				4.596237659454346,
				-0.3400000035762787
			]
		},
		{
			"mesh":12,
			"name":"Cube.003",
			"rotation":[
				0,
				0,
				-0.18223552405834198,
				0.9832549095153809
			],
			"scale":[
				-0.045032501220703125,
				-0.045032501220703125,
				-0.045032501220703125
			],
			"translation":[
				-0.7015438675880432,
				4.596237659454346,
				0.3400000035762787
			]
		}
	],
	"materials":[
		{
			"doubleSided":true,
			"name":"Material.001",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0,
					0.29299432039260864,
					0.8068727850914001,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0,
					0.0036458494141697884,
					0.043452225625514984,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material.003",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0,
					0.0036458494141697884,
					0.043452225625514984,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		}
	],
	"meshes":[
		{
			"name":"Cube.001",
			"primitives":[
				{
					"attributes":{
						"POSITION":0,
						"NORMAL":1,
						"TEXCOORD_0":2
					},
					"indices":3,
					"material":0
				}
			]
		},
		{
			"name":"Cube.002",
			"primitives":[
				{
					"attributes":{
						"POSITION":4,
						"NORMAL":5,
						"TEXCOORD_0":6
					},
					"indices":7,
					"material":0
				}
			]
		},
		{
			"name":"Cylinder",
			"primitives":[
				{
					"attributes":{
						"POSITION":8,
						"NORMAL":9,
						"TEXCOORD_0":10
					},
					"indices":11,
					"material":0
				}
			]
		},
		{
			"name":"Cylinder.001",
			"primitives":[
				{
					"attributes":{
						"POSITION":12,
						"NORMAL":13,
						"TEXCOORD_0":14
					},
					"indices":11,
					"material":0
				}
			]
		},
		{
			"name":"Cube.003",
			"primitives":[
				{
					"attributes":{
						"POSITION":15,
						"NORMAL":16,
						"TEXCOORD_0":17
					},
					"indices":18,
					"material":0
				}
			]
		},
		{
			"name":"Cube.007",
			"primitives":[
				{
					"attributes":{
						"POSITION":19,
						"NORMAL":20,
						"TEXCOORD_0":21
					},
					"indices":22,
					"material":0
				}
			]
		},
		{
			"name":"Cube.008",
			"primitives":[
				{
					"attributes":{
						"POSITION":23,
						"NORMAL":24,
						"TEXCOORD_0":25
					},
					"indices":22,
					"material":0
				}
			]
		},
		{
			"name":"Cube.005",
			"primitives":[
				{
					"attributes":{
						"POSITION":26,
						"NORMAL":27,
						"TEXCOORD_0":28
					},
					"indices":29,
					"material":0
				}
			]
		},
		{
			"name":"Cube",
			"primitives":[
				{
					"attributes":{
						"POSITION":30,
						"NORMAL":31,
						"TEXCOORD_0":32
					},
					"indices":33,
					"material":1
				}
			]
		},
		{
			"name":"Cube.004",
			"primitives":[
				{
					"attributes":{
						"POSITION":34,
						"NORMAL":35,
						"TEXCOORD_0":36
					},
					"indices":33,
					"material":1
				}
			]
		},
		{
			"name":"Cylinder.002",
			"primitives":[
				{
					"attributes":{
						"POSITION":37,
						"NORMAL":38,
						"TEXCOORD_0":39
					},
					"indices":11,
					"material":1
				}
			]
		},
		{
			"name":"Cube.006",
			"primitives":[
				{
					"attributes":{
						"POSITION":40,
						"NORMAL":41,
						"TEXCOORD_0":42
					},
					"indices":43,
					"material":1
				}
			]
		},
		{
			"name":"Cube.009",
			"primitives":[
				{
					"attributes":{
						"POSITION":44,
						"NORMAL":45,
						"TEXCOORD_0":46
					},
					"indices":43,
					"material":2
				}
			]
		}
	],
	"accessors":[
		{
			"bufferView":0,
			"componentType":5126,
			"count":224,
			"max":[
				0.9102854132652283,
				1.0557153224945068,
				0.9102854132652283
			],
			"min":[
				-0.9102854132652283,
				-0.9018439054489136,
				-0.9102854132652283
			],
			"type":"VEC3"
		},
		{
			"bufferView":1,
			"componentType":5126,
			"count":224,
			"type":"VEC3"
		},
		{
			"bufferView":2,
			"componentType":5126,
			"count":224,
			"type":"VEC2"
		},
		{
			"bufferView":3,
			"componentType":5123,
			"count":324,
			"type":"SCALAR"
		},
		{
			"bufferView":4,
			"componentType":5126,
			"count":368,
			"max":[
				0.9663493633270264,
				0.7516860961914062,
				0.9663493633270264
			],
			"min":[
				-0.9663493633270264,
				-0.7516862154006958,
				-0.9663493633270264
			],
			"type":"VEC3"
		},
		{
			"bufferView":5,
			"componentType":5126,
			"count":368,
			"type":"VEC3"
		},
		{
			"bufferView":6,
			"componentType":5126,
			"count":368,
			"type":"VEC2"
		},
		{
			"bufferView":7,
			"componentType":5123,
			"count":516,
			"type":"SCALAR"
		},
		{
			"bufferView":8,
			"componentType":5126,
			"count":192,
			"max":[
				1,
				1,
				1
			],
			"min":[
				-1,
				-1,
				-1
			],
			"type":"VEC3"
		},
		{
			"bufferView":9,
			"componentType":5126,
			"count":192,
			"type":"VEC3"
		},
		{
			"bufferView":10,
			"componentType":5126,
			"count":192,
			"type":"VEC2"
		},
		{
			"bufferView":11,
			"componentType":5123,
			"count":372,
			"type":"SCALAR"
		},
		{
			"bufferView":12,
			"componentType":5126,
			"count":192,
			"max":[
				1,
				1,
				1
			],
			"min":[
				-1,
				-1,
				-1
			],
			"type":"VEC3"
		},
		{
			"bufferView":13,
			"componentType":5126,
			"count":192,
			"type":"VEC3"
		},
		{
			"bufferView":14,
			"componentType":5126,
			"count":192,
			"type":"VEC2"
		},
		{
			"bufferView":15,
			"componentType":5126,
			"count":72,
			"max":[
				1.3481193780899048,
				0.44371485710144043,
				0.9865543842315674
			],
			"min":[
				-0.8679153919219971,
				-0.5842263102531433,
				-0.6333475112915039
			],
			"type":"VEC3"
		},
		{
			"bufferView":16,
			"componentType":5126,
			"count":72,
			"type":"VEC3"
		},
		{
			"bufferView":17,
			"componentType":5126,
			"count":72,
			"type":"VEC2"
		},
		{
			"bufferView":18,
			"componentType":5123,
			"count":132,
			"type":"SCALAR"
		},
		{
			"bufferView":19,
			"componentType":5126,
			"count":30,
			"max":[
				1.3272992372512817,
				0.21638387441635132,
				1
			],
			"min":[
				-2.4162750244140625,
				-1,
				-1.789177417755127
			],
			"type":"VEC3"
		},
		{
			"bufferView":20,
			"componentType":5126,
			"count":30,
			"type":"VEC3"
		},
		{
			"bufferView":21,
			"componentType":5126,
			"count":30,
			"type":"VEC2"
		},
		{
			"bufferView":22,
			"componentType":5123,
			"count":48,
			"type":"SCALAR"
		},
		{
			"bufferView":23,
			"componentType":5126,
			"count":30,
			"max":[
				1.3272992372512817,
				0.21638387441635132,
				1
			],
			"min":[
				-2.4162750244140625,
				-1,
				-1.7891775369644165
			],
			"type":"VEC3"
		},
		{
			"bufferView":24,
			"componentType":5126,
			"count":30,
			"type":"VEC3"
		},
		{
			"bufferView":25,
			"componentType":5126,
			"count":30,
			"type":"VEC2"
		},
		{
			"bufferView":26,
			"componentType":5126,
			"count":72,
			"max":[
				1.3481192588806152,
				0.6197910308837891,
				0.5966057777404785
			],
			"min":[
				-0.8679153919219971,
				-0.9439473152160645,
				-0.5283350944519043
			],
			"type":"VEC3"
		},
		{
			"bufferView":27,
			"componentType":5126,
			"count":72,
			"type":"VEC3"
		},
		{
			"bufferView":28,
			"componentType":5126,
			"count":72,
			"type":"VEC2"
		},
		{
			"bufferView":29,
			"componentType":5123,
			"count":132,
			"type":"SCALAR"
		},
		{
			"bufferView":30,
			"componentType":5126,
			"count":24,
			"max":[
				0.12331390380859375,
				0.3768068552017212,
				0.13226842880249023
			],
			"min":[
				-0.12331390380859375,
				-0.3768068552017212,
				-0.13226830959320068
			],
			"type":"VEC3"
		},
		{
			"bufferView":31,
			"componentType":5126,
			"count":24,
			"type":"VEC3"
		},
		{
			"bufferView":32,
			"componentType":5126,
			"count":24,
			"type":"VEC2"
		},
		{
			"bufferView":33,
			"componentType":5123,
			"count":36,
			"type":"SCALAR"
		},
		{
			"bufferView":34,
			"componentType":5126,
			"count":24,
			"max":[
				0.12331390380859375,
				0.3768068552017212,
				0.13226842880249023
			],
			"min":[
				-0.12331390380859375,
				-0.3768068552017212,
				-0.13226830959320068
			],
			"type":"VEC3"
		},
		{
			"bufferView":35,
			"componentType":5126,
			"count":24,
			"type":"VEC3"
		},
		{
			"bufferView":36,
			"componentType":5126,
			"count":24,
			"type":"VEC2"
		},
		{
			"bufferView":37,
			"componentType":5126,
			"count":192,
			"max":[
				1,
				-0.8872233629226685,
				1
			],
			"min":[
				-1.0000001192092896,
				-1,
				-1
			],
			"type":"VEC3"
		},
		{
			"bufferView":38,
			"componentType":5126,
			"count":192,
			"type":"VEC3"
		},
		{
			"bufferView":39,
			"componentType":5126,
			"count":192,
			"type":"VEC2"
		},
		{
			"bufferView":40,
			"componentType":5126,
			"count":112,
			"max":[
				0.8942676782608032,
				1.0296698808670044,
				3.094804048538208
			],
			"min":[
				-0.6190509796142578,
				-1,
				-3.094804048538208
			],
			"type":"VEC3"
		},
		{
			"bufferView":41,
			"componentType":5126,
			"count":112,
			"type":"VEC3"
		},
		{
			"bufferView":42,
			"componentType":5126,
			"count":112,
			"type":"VEC2"
		},
		{
			"bufferView":43,
			"componentType":5123,
			"count":192,
			"type":"SCALAR"
		},
		{
			"bufferView":44,
			"componentType":5126,
			"count":112,
			"max":[
				0.8942676782608032,
				1.0296698808670044,
				3.094804048538208
			],
			"min":[
				-0.6190509796142578,
				-1,
				-3.094804048538208
			],
			"type":"VEC3"
		},
		{
			"bufferView":45,
			"componentType":5126,
			"count":112,
			"type":"VEC3"
		},
		{
			"bufferView":46,
			"componentType":5126,
			"count":112,
			"type":"VEC2"
		}
	],
	"bufferViews":[
		{
			"buffer":0,
			"byteLength":2688,
			"byteOffset":0,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2688,
			"byteOffset":2688,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1792,
			"byteOffset":5376,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":648,
			"byteOffset":7168,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":4416,
			"byteOffset":7816,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":4416,
			"byteOffset":12232,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2944,
			"byteOffset":16648,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1032,
			"byteOffset":19592,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":20624,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":22928,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1536,
			"byteOffset":25232,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":744,
			"byteOffset":26768,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":27512,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":29816,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1536,
			"byteOffset":32120,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":864,
			"byteOffset":33656,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":864,
			"byteOffset":34520,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":576,
			"byteOffset":35384,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":264,
			"byteOffset":35960,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":360,
			"byteOffset":36224,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":360,
			"byteOffset":36584,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":240,
			"byteOffset":36944,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":96,
			"byteOffset":37184,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":360,
			"byteOffset":37280,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":360,
			"byteOffset":37640,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":240,
			"byteOffset":38000,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":864,
			"byteOffset":38240,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":864,
			"byteOffset":39104,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":576,
			"byteOffset":39968,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":264,
			"byteOffset":40544,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":40808,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":41096,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":192,
			"byteOffset":41384,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":72,
			"byteOffset":41576,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":41648,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":41936,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":192,
			"byteOffset":42224,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":42416,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":44720,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1536,
			"byteOffset":47024,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1344,
			"byteOffset":48560,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1344,
			"byteOffset":49904,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":896,
			"byteOffset":51248,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":384,
			"byteOffset":52144,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":1344,
			"byteOffset":52528,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1344,
			"byteOffset":53872,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":896,
			"byteOffset":55216,
			"target":34962
		}
	],
	"buffers":[
		{
			"byteLength":56112,
			"uri":"player_blue.bin"
		}
	]
}
